var AT_Main = {

  getWidthBrowser : function() { // Get width browser
    var myWidth;

    if( typeof( window.innerWidth ) == 'number' ) {
      //Non-IE
      myWidth = window.innerWidth;
    }
    else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) {
      //IE 6+ in 'standards compliant mode'
      myWidth = document.documentElement.clientWidth;
    }
    else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) {
      //IE 4 compatible
      myWidth = document.body.clientWidth;
    }

    return myWidth;
  }

  ,checkLayout : function() { // Function to check level of layout
    if(jQuery("#checkLayout .d-sm-block").css("display") == "block")
      return 1; //mobile layout
    else if(jQuery("#checkLayout .d-md-block").css("display") == "block")
      return 2; //tablet potrait layout
    else if(jQuery("#checkLayout .d-lg-block").css("display") == "block")
      return 3; //tablet landscape/medium desktop layout
    else if(jQuery("#checkLayout .d-xl-block").css("display") == "block")
      return 4; //desktop layout
  }

  ,homeSlideshow : function(){
    if(jQuery('.home-slideshow-wrapper').length){
      jQuery('.home-slideshow-wrapper').each(function(index,value){

        var _delay_time = '';
        if(jQuery(value).data('autoplay')){
          _delay_time = jQuery(value).data('time');
        }

        var swiper = new Swiper('.swiper-container', {
          autoplay: _delay_time
          ,loop: true
          ,simulateTouch:true
          ,pagination: '.swiper-pagination'
          ,paginationClickable: '.swiper-pagination'
          ,nextButton: '.swiper-button-next'
          ,prevButton: '.swiper-button-prev'
          ,spaceBetween: 30
          ,scrollbarDraggable: true
          ,effect: jQuery(value).data('animation')
          ,setWrapperSize: false
          ,onImagesReady: function(swiper){
            var slideH = $(swiper.container[0]).find('.swiper-slide > img').height(),
            slideW = $(swiper.container[0]).find('.swiper-slide > img').width();
            $(swiper.container[0]).find('.swiper-slide > img').css('visibility','hidden');
            $(swiper.container[0]).find('.swiper-slide').each(function(){
              var _this = $(this);
              _this.find('.video-slide').show();
              _this.find('.video-slide video').css({
                left: '50%',
                top: '50%',
                transform: 'translate(-50%,-50%)'
              });
            });
          }
        });
      });
    }
  }

  ,homeIE : function(){
    if(jQuery('.home-slideshow-wrapper').length){
      jQuery('.home-slideshow-wrapper').each(function(index,value){

        var _delay_time = '';
        if(jQuery(value).data('autoplay')){
          _delay_time = jQuery(value).data('time');
        }

        var swiper = new Swiper('.swiper-container', {
          autoplay: _delay_time
          ,loop: true
          ,simulateTouch:true
          ,pagination: '.swiper-pagination'
          ,paginationClickable: '.swiper-pagination'
          ,nextButton: '.swiper-button-next'
          ,prevButton: '.swiper-button-prev'
          ,spaceBetween: 30
          ,scrollbarDraggable: true
          ,effect: 'fade'
          ,setWrapperSize: true
          ,onImagesReady: function(swiper){
            var slideH = $(swiper.container[0]).find('.swiper-slide > img').height(),
            slideW = $(swiper.container[0]).find('.swiper-slide > img').width();
            $(swiper.container[0]).find('.swiper-slide > img').css('visibility','hidden');
            $(swiper.container[0]).find('.swiper-slide').each(function(){
              var _this = $(this);
              _this.find('.video-slide').show();
              _this.find('.video-slide video').css({
                left: '50%',
                top: '50%',
                transform: 'translate(-50%,-50%)'
              });
            });
          }
        });
      });
    }
  }
  ,mouseIn: function(selector) {
    if (selector.hasClass('swiper-button-prev')) {

     var bg = $('.swiper-wrapper').find('.swiper-slide-active').prev().css("background-image");

     if (typeof(bg) == 'undefined') {
      bg = $('.swiper-slide').last().prev().prev().css("background-image");
     }

     $('.swiper-button-prev').find('.img-thumb').css({
      "background": bg,
      "background-position": "center",
      "background-size": "cover",
      "opacity": "1"
      ,"transform": "translate(100px,0)"
     });

    }
    else {

     var bg = $('.swiper-wrapper').find('.swiper-slide-active').next().css("background-image");

     if (typeof(bg) == 'undefined') {
      bg = $('.swiper-slide').first().next().next().css("background-image");
     }
     $('.swiper-button-next').find('.img-thumb').css({
      "background": bg,
      "background-position": "center",
      "background-size": "cover",
      "opacity": "1"
      ,"transform": "translate(-100px,0)"
     });
    }
  }

  ,mouseOut: function() {
      $(".swiper-button-white").css("background", "rgba(0,0,0,0.25)");
      $(".swiper-button-white .img-thumb").css("opacity","0").css("transform","translate(0,0)");
  }

  ,stickMenu: function() {
    var enable_stick = jQuery(".header-content").data('stick');
    if (enable_stick && !$('body').hasClass('theme-left-menu')) {
     //Keep track of last scroll
     var lastScroll = 0;
     var header = jQuery(".header-container");
     var body_content = jQuery("#body-content");

     jQuery(window).scroll(function() {
      //Sets the current scroll position
      var st = jQuery(this).scrollTop();
      //Determines up-or-down scrolling
      if (st > lastScroll) {

       //Replace this with your function call for downward-scrolling
       if (st > 250) {
        header.addClass("header-fixed fadeInDown animated");
        body_content.addClass("has-header-fixed");
       }
      } else {
       //Replace this with your function call for upward-scrolling
       if (st < 250) {
        header.removeClass("header-fixed fadeInDown animated");
        body_content.removeClass("has-header-fixed");
       }
      }
      //Updates scroll position
      lastScroll = st;
     });
    }

  }

  ,stickAddToCart : function() {
    $(window).on( 'scroll' , function() {
      var ps = jQuery(this).scrollTop();
      var _show_sticky = ($('#add-to-cart').offset().top);

      if ( _show_sticky < ps ) {
        $('.add-to-cart-sticky').addClass('show');
      }
      else {
        $('.add-to-cart-sticky').removeClass('show');
      }
    });
    }
  ,toTopButton : function(){
    var to_top_btn = $("#scroll-to-top");
    if( 1 > to_top_btn.length ){
      return;
    }
    $(window).on( 'scroll' , function() {
      var b = jQuery(this).scrollTop();
      var c = jQuery(this).height();
      if (b > 100) {
        var d = b + c / 2;
      }
      else {
        var d = 1 ;
      }

      if (d < 1000 && d < c) {
        jQuery("#scroll-to-top").removeClass('on off').addClass('off');
        jQuery("#show-popup-sub").removeClass('on off').addClass('off');
      } else {
        jQuery("#scroll-to-top").removeClass('on off').addClass('on');
        jQuery("#show-popup-sub").removeClass('on off').addClass('on');
      }
    });

    to_top_btn.on( 'click',function (e) {
      e.preventDefault();
      jQuery('body,html').animate({scrollTop:0},800,'swing');
    });

    jQuery("#show-popup-sub").on( 'click',function (e) {
      e.preventDefault();
      let el = $('#mailchimp-popup');
      if(el.length){
        if((el.data('style') == 'delay')){
          $.fancybox.open({
            src  : '#mailchimp-popup',
            type : 'inline'
          })
        }else if(el.data('style') == 'leaves'){
          el.css('display') == 'none' ? el.css('display','block') : el.css('display','none');
        }
      }
    });
  }

  ,mailchipPopup : function(){
    var expire = jQuery("#mailchimp-popup").data('expires');
    if (jQuery.cookie('mycookie')) {
      //it hasn't been one days yet
    }
    else {
      var _style = jQuery("#mailchimp-popup").data('style');

      if(_style == 'delay'){
        setTimeout(function(){
          $.fancybox.open({
            src  : '#mailchimp-popup',
            type : 'inline'
          })
        }, jQuery("#mailchimp-popup").data('delay'));
      }

      else if(_style == 'leaves'){
        var _dis = ouibounce(document.getElementById('mailchimp-popup'), {
          aggressive: true,
          timer: 0
        });

      }
    }
    $('#mailchimp-popup.leaves .leaves--close, #mailchimp-popup.leaves .underlay').on('click', function() {
      $('#mailchimp-popup').hide();
    });
    jQuery.cookie('mycookie', 'true', { expires: expire });
  }
  ,toggleVerticalMenu : function(){
    jQuery(document).on('click', '.vertical-menu .head', function(e) {
      jQuery(this).parent().toggleClass('opened');
    });
  }

  ,toggleCartSidebar : function(){
    jQuery('.cart-toggle').on('click',function (e) {
      e.stopPropagation();
      AT_Main.fixNoScroll();
      jQuery('.cart-sb').toggleClass('opened');
      jQuery('body').toggleClass('cart-opened');
    });

    jQuery('#page-body, .c-close').on('click',function () {
      jQuery('.cart-sb').removeClass('opened');
      jQuery('html,body').removeClass('cart-opened');
      jQuery(".dropdown").removeClass("menu-mobile-open");
      AT_Main.fixReturnScroll();
    });

    jQuery('.am-close').on('click',function (e) {
      jQuery('.layer-addcart-modal').removeClass('show');
    });
  }

  ,toggleFilterSidebar : function(){
    jQuery(document).on('click','.filter-icon.toggle',function (e) {
      jQuery('.filter-component').slideToggle("slow");
    });
    jQuery(document).on('click','.filter-icon.drawer',function (e) {
      e.stopPropagation();
      AT_Main.fixNoScroll();
      jQuery('body').toggleClass('sidebar-opened');
    });

    jQuery('#page-body').on('click',function () {
      jQuery('html,body').removeClass('sidebar-opened');
      AT_Main.fixReturnScroll();
    });

    jQuery('.f-close').on('click',function () {
      jQuery('#sidebar').removeClass('opened');
      jQuery('html,body').removeClass('sidebar-opened');
      AT_Main.fixReturnScroll();
    });

    jQuery('.filter-icon-order').on('click',function (e) {
      e.stopPropagation();
      AT_Main.fixNoScroll();
      jQuery('body').toggleClass('order-sidebar-opened');
    });

    jQuery('#page-body').on('click',function () {
      jQuery('html,body').removeClass('order-sidebar-opened');
      AT_Main.fixReturnScroll();
    });

    jQuery('.fof-close').on('click',function () {
      jQuery('html,body').removeClass('order-sidebar-opened');
      AT_Main.fixReturnScroll();
    });
  }
  ,handleGridList : function(){
    if ($('.page-cata').data('mode-view') == false) { AT_Main.clearCookieGridList(); }

    if($.cookie('view-cata-list')===null){

      // LIST VIEW
      
      $.cookie('view-cata-list','no', {expires: 1, path: '/'});
      $(".templateIndex .mode-view-item,.templateCollection .mode-view-item").addClass("product-grid-item");
      
      $(".templateIndex .mode-view-item,.templateCollection .mode-view-item").addClass("number-4");
      $(".grid-4").addClass("active");$.cookie('cata-grid-4','yes',  {expires: 1, path: '/'});
      

      $(".templateIndex .grid-list .grid").removeClass("active");
      $(".templateIndex .grid-list .list").addClass("active");
      

    }else{
      if($('body').hasClass("templateIndex")){
        if ($.cookie('view-cata-list') == "yes" ) {

          $(".grid-list .grid").removeClass("active");$(".grid-list .list").addClass("active");
          AT_Main.handleGridList_Remove();
          $("body").addClass("view-cata-list");
          $(".templateIndex .mode-view-item").addClass("product-list-item");

          
          $(".templateIndex .mode-view-item").addClass("number-1");
          
        }else{
          $(".grid-list .list").removeClass("active");$(".grid-list .grid").addClass("active");
          AT_Main.handleGridList_Remove();
          $(".templateIndex .mode-view-item").addClass("product-grid-item");
          
          $(".templateIndex .mode-view-item").addClass("number-4");
          
        }
      }else{
        let config = function(e,grid,num){
          AT_Main.handleGridList_Remove();
          $("body").addClass(e);
          $('.grid').each(function() {
            $(this).removeClass("active");
          });
          $(grid).addClass("active");
          $('.templateCollection .mode-view-item').addClass(num);
        }

        if ($.cookie('cata-grid-6') == "yes") {
          config("cata-grid-6",".grid-6","product-grid-item number-6")
        }
        if ($.cookie('cata-grid-5') == "yes") {
          config("cata-grid-5",".grid-5","product-grid-item number-5")
        }
        if ($.cookie('cata-grid-4') == "yes") {
          config("cata-grid-4",".grid-4","product-grid-item number-4")
        }
        if ($.cookie('cata-grid-3') == "yes") {
          config("cata-grid-3",".grid-3","product-grid-item number-3")
        }
        if ($.cookie('cata-grid-2') == "yes") {
          config("cata-grid-2",".grid-2","product-grid-item number-2")
        }
        if ($.cookie('cata-list-2') == "yes") {
          config("view-cata-list cata-list-2",".list-2","product-list-item number-2")
        }
        if ($.cookie('cata-list-1') == "yes") {
          config("view-cata-list cata-list-1",".list-1","product-list-item number-1")
        }
      }
    }

    jQuery(".templateIndex").on("click", ".grid", function() {
      AT_Main.handleGridList_Remove();
      // var e = jQuery(this).closest(".view-mode");
      $.cookie('view-cata-list','no',  {expires: 1, path: '/'});
      $(".templateIndex .mode-view-item").addClass("product-grid-item");

      
      $(".templateIndex .mode-view-item").addClass("number-4");
      

      if ($('body').hasClass('templateIndex')) {
        $('.templateIndex .cata-product').isotope();
      }

      $(".grid-list .list").removeClass("active");
      $(".grid-list .grid").addClass("active");
    })

    jQuery(".templateIndex").on("click", ".list", function() {
      AT_Main.handleGridList_Remove();
      $("body").addClass("view-cata-list");
      // var e = jQuery(this).closest(".view-mode");
      $.cookie('view-cata-list','yes', {expires: 1, path: '/'});
      jQuery("body").addClass("view-cata-list");
      $(".templateIndex .mode-view-item").addClass("product-list-item");
      
      $(".templateIndex .mode-view-item").addClass("number-1");
      

      if ($('body').hasClass('templateIndex')) {
        $('.templateIndex .cata-product').isotope();
      }
      $(".grid-list .grid").removeClass("active");
      $(".grid-list .list").addClass("active");
    })

    jQuery(".templateCollection").on("click", ".grid-6", function() {
      $.cookie('cata-grid-6','yes', {expires: 1, path: '/'});
      $.cookie('cata-grid-5','no',  {expires: 1, path: '/'});
      $.cookie('cata-grid-4','no',  {expires: 1, path: '/'});
      $.cookie('cata-grid-3','no',  {expires: 1, path: '/'});
      $.cookie('cata-grid-2','no',  {expires: 1, path: '/'});
      $.cookie('cata-list-2','no',  {expires: 1, path: '/'});
      $.cookie('cata-list-1','no',  {expires: 1, path: '/'});

      AT_Main.handleGridList_Remove();
      jQuery("body").addClass("cata-grid-6");

      var e = jQuery(this).closest(".grid-list");
      e.children('.grid').each(function() {
        $(this).removeClass("active");
      });
      $(this).addClass("active");
      $('.mode-view-item').addClass('product-grid-item number-6');
    })
    jQuery(".templateCollection").on("click", ".grid-5", function() {
      $.cookie('cata-grid-6','no',  {expires: 1, path: '/'});
      $.cookie('cata-grid-5','yes',  {expires: 1, path: '/'});
      $.cookie('cata-grid-4','no',  {expires: 1, path: '/'});
      $.cookie('cata-grid-3','no',  {expires: 1, path: '/'});
      $.cookie('cata-grid-2','no',  {expires: 1, path: '/'});
      $.cookie('cata-list-2','no',  {expires: 1, path: '/'});
      $.cookie('cata-list-1','no',  {expires: 1, path: '/'});
      $.cookie('view-cata-list','no', {expires: 1, path: '/'});
      AT_Main.handleGridList_Remove();
      jQuery("body").addClass("cata-grid-5");

      var e = jQuery(this).closest(".grid-list");
      e.children('.grid').each(function() {
        $(this).removeClass("active");
      });
      $(this).addClass("active");
      $('.mode-view-item').addClass('product-grid-item number-5');
    })
    jQuery(".templateCollection").on("click", ".grid-4", function() {
      $.cookie('cata-grid-6','no',  {expires: 1, path: '/'});
      $.cookie('cata-grid-5','no',  {expires: 1, path: '/'});
      $.cookie('cata-grid-4','yes',  {expires: 1, path: '/'});
      $.cookie('cata-grid-3','no',  {expires: 1, path: '/'});
      $.cookie('cata-grid-2','no',  {expires: 1, path: '/'});
      $.cookie('cata-list-2','no',  {expires: 1, path: '/'});
      $.cookie('cata-list-1','no',  {expires: 1, path: '/'});
      $.cookie('view-cata-list','no', {expires: 1, path: '/'});
      AT_Main.handleGridList_Remove();
      jQuery("body").addClass("cata-grid-4");

      var e = jQuery(this).closest(".grid-list");
      e.children('.grid').each(function() {
        $(this).removeClass("active");
      });
      $(this).addClass("active");
      $('.mode-view-item').addClass('product-grid-item number-4');
    })
    jQuery(".templateCollection").on("click", ".grid-3", function() {
      $.cookie('cata-grid-6','no',  {expires: 1, path: '/'});
      $.cookie('cata-grid-5','no',  {expires: 1, path: '/'});
      $.cookie('cata-grid-4','no',  {expires: 1, path: '/'});
      $.cookie('cata-grid-3','yes',  {expires: 1, path: '/'});
      $.cookie('cata-grid-2','no',  {expires: 1, path: '/'});
      $.cookie('cata-list-2','no',  {expires: 1, path: '/'});
      $.cookie('cata-list-1','no',  {expires: 1, path: '/'});
      $.cookie('view-cata-list','no', {expires: 1, path: '/'});
      AT_Main.handleGridList_Remove();
      jQuery("body").addClass("cata-grid-3");

      var e = jQuery(this).closest(".grid-list");
      e.children('.grid').each(function() {
        $(this).removeClass("active");
      });
      $(this).addClass("active");
      $('.mode-view-item').addClass('product-grid-item number-3');
    })
    jQuery(".templateCollection").on("click", ".grid-2", function() {
      $.cookie('cata-grid-6','no',  {expires: 1, path: '/'});
      $.cookie('cata-grid-5','no',  {expires: 1, path: '/'});
      $.cookie('cata-grid-4','no',  {expires: 1, path: '/'});
      $.cookie('cata-grid-3','no',  {expires: 1, path: '/'});
      $.cookie('cata-grid-2','yes',  {expires: 1, path: '/'});
      $.cookie('cata-list-2','no',  {expires: 1, path: '/'});
      $.cookie('cata-list-1','no',  {expires: 1, path: '/'});
      $.cookie('view-cata-list','no', {expires: 1, path: '/'});
      AT_Main.handleGridList_Remove();
      jQuery("body").addClass("cata-grid-2");

      var e = jQuery(this).closest(".grid-list");
      e.children('.grid').each(function() {
        $(this).removeClass("active");
      });
      $(this).addClass("active");
      $('.mode-view-item').addClass('product-grid-item number-2');
    })
    jQuery(".templateCollection").on("click", ".list-2", function() {
      $.cookie('cata-grid-6','no',  {expires: 1, path: '/'});
      $.cookie('cata-grid-5','no',  {expires: 1, path: '/'});
      $.cookie('cata-grid-4','no',  {expires: 1, path: '/'});
      $.cookie('cata-grid-3','no',  {expires: 1, path: '/'});
      $.cookie('cata-grid-2','no',  {expires: 1, path: '/'});
      $.cookie('cata-list-2','yes',  {expires: 1, path: '/'});
      $.cookie('cata-list-1','no',  {expires: 1, path: '/'});
      $.cookie('view-cata-list','yes', {expires: 1, path: '/'});
      AT_Main.handleGridList_Remove();
      jQuery("body").addClass("view-cata-list cata-list-2");

      var e = jQuery(this).closest(".grid-list");
      e.children('.grid').each(function() {
        $(this).removeClass("active");
      });
      $(this).addClass("active");
      $('.mode-view-item').addClass('product-list-item number-2');
    })
    jQuery(".templateCollection").on("click", ".list-1", function() {
      $.cookie('cata-grid-6','no',  {expires: 1, path: '/'});
      $.cookie('cata-grid-5','no',  {expires: 1, path: '/'});
      $.cookie('cata-grid-4','no',  {expires: 1, path: '/'});
      $.cookie('cata-grid-3','no',  {expires: 1, path: '/'});
      $.cookie('cata-grid-2','no',  {expires: 1, path: '/'});
      $.cookie('cata-list-2','no',  {expires: 1, path: '/'});
      $.cookie('cata-list-1','yes',  {expires: 1, path: '/'});
      $.cookie('view-cata-list','yes', {expires: 1, path: '/'});
      AT_Main.handleGridList_Remove();
      jQuery("body").addClass("view-cata-list cata-list-1");

      var e = jQuery(this).closest(".grid-list");
      e.children('.grid').each(function() {
        $(this).removeClass("active");
      });
      $(this).addClass("active");
      $('.mode-view-item').addClass('product-list-item number-1');
    })
    setTimeout(function(){
      $(".mode-view-item").removeClass('opacity-0');
    },500);
  }

  ,handleGridList_Remove : function(){
    jQuery("body").removeClass("view-cata-list cata-grid-2 cata-grid-3 cata-grid-4 cata-grid-5 cata-grid-6 cata-list-1 cata-list-2");
    jQuery('.mode-view-item').removeClass('number-1 number-2 number-3 number-4 number-5 number-6 product-grid-item product-list-item');
  }
  ,clearCookieGridList : function(){
    $.cookie("cata-grid-6", null, { path: '/' });
    $.cookie("cata-grid-5", null, { path: '/' });
    $.cookie("cata-grid-4", null, { path: '/' });
    $.cookie("cata-grid-3", null, { path: '/' });
    $.cookie("cata-grid-2", null, { path: '/' });
    $.cookie("cata-list-2", null, { path: '/' });
    $.cookie("cata-list-1", null, { path: '/' });
    $.cookie("view-cata-list", null, { path: '/' });

  }
  ,handleOrderFormQty : function(){
    jQuery("body").on("click",".global-product-info-qty-plus",function(){
      q = $(this).prev();
      var value = parseInt(q.val(), 10);
      value = isNaN(value) ? 0 : value;
      value++;
      q.val(value);
    });

    jQuery("body").on("click",".global-product-info-qty-minus",function(){
      q = $(this).next();
      var value = parseInt(q.val(), 10);
      value = isNaN(value) ? 1 : value;
      if(value > 0){
        value--;
        q.val(value);
      }
    });
  }

  ,effectNavigation : function(){ // Make hover effect of navigation

    jQuery(".top-account-holder").hover(function(e){
      jQuery(this).find('>.dropdown-menu').addClass("fadeInUp animated");
    },function(e){
      jQuery(this).find('>.dropdown-menu').removeClass("fadeInUp animated");
    });

    jQuery(".currency-block").hover(function(e){
      jQuery(this).find('>.dropdown-menu').addClass("fadeInUp animated");
    },function(e){
      jQuery(this).find('>.dropdown-menu').removeClass("fadeInUp animated");
    });

    jQuery(document).on('click','.searchbox>a',function(e){
      $(this).parents().find('.searchbox').toggleClass('open');
      $('#page-body').trigger('click');
    });

    jQuery('#city-phone-numbers').on("change", function(e) {
      var _newcity = jQuery(e.currentTarget).find(':selected').attr('value');
      $('#city-phone-number-label').html(_newcity);
    });

  }

  ,fixNoScroll : function() { // Fixed persitent position of page when scroll disapear
    var windowW = jQuery(window).width();
    jQuery('#page-body, .header-content, #page-body .mobile-version').css("width", windowW + 'px');
  }

  ,fixReturnScroll : function() {jQuery('#page-body, .header-content,#page-body .mobile-version').attr('style', '');}

  ,fixButton : function(){
    jQuery(".product-wrapper .product-head").each(function(e){
      if($(this).children().hasClass('wrapper-countdown')){
        $(this).find('.product-button').addClass('fix');
      }
    });
  }

  ,handleReviews: function() {SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges();}

  ,menuOnMobile : function(){
    jQuery(document).on('click',function(e){
      // console.log(e.target.id);
    })
    jQuery('#page-body, .show-compare').on('click',function (e) {
      if (jQuery(".menu-mobile").hasClass('opened') ) {
        jQuery(".menu-mobile").removeClass("opened");
        jQuery("html,body").removeClass("menu-opened");
        AT_Main.fixReturnScroll();
      }
    });

    jQuery('.mm-block-icons .wishlist-target, .mm-block-icons .compare-target, .m-close').on('click',function () {
      jQuery(".menu-mobile").removeClass("opened");
      jQuery("html,body").removeClass("menu-opened");
      AT_Main.fixReturnScroll();
    });

    jQuery(document).on('click','.responsive-menu',function(e){
      //e.stopPropagation();

      AT_Main.fixNoScroll();
      jQuery(".menu-mobile").toggleClass("opened");
      jQuery("html,body").toggleClass("menu-opened")

    });

    jQuery(".navbar .main-nav li").hover(function(){
      if (!jQuery(this).parents('.mobile-version')){
        jQuery(this).addClass("hover")
      }
    },function(){
      jQuery(this).removeClass("hover")}
      );

    jQuery(document).on('click','.currency_wrapper',function(){
      if ($('.currency-block').hasClass("opened")) {
        $('.currency-block').removeClass("opened");
      } else {
        $('.currency-block').addClass("opened");
      }
    });

    jQuery(document).on('click','.bc-toggle',function(){

      var e=jQuery(this);
      if (e.hasClass("opened")) {
        e.removeClass("opened");
      } else {
        e.addClass("opened");
      }
    });

    jQuery(document).on('click','.top-cart-holder.hover-dropdown .cart-target',function(){
      var e=jQuery(this);
      if (e.hasClass("opened")) {
        e.removeClass("opened");
      } else {
        e.addClass("opened");
      }
    });

  }

  ,handleMenuMultiLine : function() {
    var outItem = "";
    var down = false;

    var top = 0;

    jQuery(".navbar-collapse .main-nav > li").on("mousemove", function(e){
      var target = jQuery(e.currentTarget);

      if( down && outItem != "") {
        outItem.addClass("hold");
        setTimeout(function(){
          if(outItem != "")
            outItem.removeClass("hold");
          down = false;
          outItem = "";
        },500);

        if( (outItem[0] == target[0]) || (outItem.offset().top == target.offset().top) )
        {
          outItem.removeClass("hold");
          down = false;
          outItem = "";
        }
      }
      else {
        outItem = "";
      }

    });

    jQuery(".navbar-collapse .main-nav >li").on("mouseout", function(e){

      var target = jQuery(e.currentTarget);

      if( e.pageY >= target.offset().top + 50 ) { //move down
        down = true;
      }

      if( target.hasClass("dropdown") ) { //target has child

        if(outItem == "")
          outItem = target;
      }

    });
  }


  ,fixTitle : function(){ // fix title a in filter & swatch size in detail product page
    jQuery(".rt a").attr("data-title", function() { return jQuery(this).attr("title"); });
    jQuery(".rt a").removeAttr("title");

    jQuery(".size-all").after(jQuery(".size-xxxl")).after(jQuery(".size-xxl")).after(jQuery(".size-xl")).after(jQuery(".size-l")).after(jQuery(".size-m")).after(jQuery(".size-x")).after(jQuery(".size-s")).after(jQuery(".size-xs")).after(jQuery(".size-xxs")).after(jQuery(".size-xxxs"));
  }

  ,filterCatalogReplace : function(collectionUrl, filter_id){

    var value = collectionUrl.substring(collectionUrl.lastIndexOf('/') + 1);
    var val = value.substring(value.lastIndexOf('?'));

    collectionUrl = collectionUrl.replace(value, '');

    value = value.replace(val, '');
    value = value.replace('#', '');

    var value_arr = value.split('+');

    var current_arr = [];
    jQuery('#'+filter_id+' li.active-filter').each( function() {
      current_arr.push(jQuery(this).attr('data-handle'));
    });

    jQuery('#'+filter_id+' li.active-filter').find('a').attr('title', '');
    jQuery('#'+filter_id+' li').removeClass('active-filter');

    for(jQueryi = 0; jQueryi<current_arr.length; jQueryi++) {
      value_arr = jQuery.grep(value_arr, function( n, i ) { return ( n !== current_arr[jQueryi]  ); });
    }

    var new_data = value_arr.join('+')

    var new_url = collectionUrl+new_data+val;

    if( typeof AT_Filter != 'undefined' && AT_Filter ){
      AT_Filter.updateURL = true;
      AT_Filter.requestPage(new_url);
    }else{
      window.location = new_url;
    }

  }
  ,filterCatalog_AccordionHandle : function(){
    let filters = jQuery('.advanced-filter');
    if(filters.parents('.accordion').length > 0){
      $('.advanced-filters').each(function () {
        let parent = $(this);

        let active = false;
        parent.children('.advanced-filter').each(function(){
          if ($(this).hasClass('active-filter')) {
            active = true;
          }
        })

        if (active) {
          parent.parent().addClass('active del-before');
        }else{
          parent.parent().removeClass('active del-before');
        }
      })
    }
  }

  ,filterCatalog : function(){
    var currentTags = ''
    ,filters  = jQuery('.advanced-filter');

    filters.each(function() {
      var el = jQuery(this)
      ,group = el.data('group');

      if ( el.hasClass('active-filter') ) { //Remove class hidden
        el.parents('.sb-filter').find('a.clear-filter').removeClass('hidden');
      }
    });
    AT_Main.filterCatalog_AccordionHandle();

    filters.on('click', function(e) {
      var el = $(this)
      ,group = el.data('group')
      ,url = el.find('a').attr('href')

        // Continue as normal if we're clicking on the active link
        if ( el.hasClass('active-filter') ) {
          return;
        }

        AT_Main.filterCatalog_AccordionHandle();

        var _logic = jQuery(".page-cata").data('logic');
        if( _logic){
            // Get active group link (unidentified if there isn't one)
            activeTag = $('.active-filter[data-group="'+ group +'"]');
            // If a tag from this group is already selected, remove it from the new tag's URL and continue
            if ( activeTag && activeTag.data('group') === group ) {
              e.preventDefault();
              activeHandle = activeTag.data('handle') + '+';

              // Create new URL without the currently active handle
              url = url.replace(activeHandle, '');

              window.location = url;
            }
          }
        });

    jQuery('.sb-filter').on('click', '.clear-filter', function(n){ // Handle button clear
      n.preventDefault();
      var filter_id = jQuery(this).attr('id');
      filter_id = filter_id.replace('clear-', '');

      var collectionUrl = window.location.href;

      if(collectionUrl.match(/\?/)){
        var string = collectionUrl.substring(collectionUrl.lastIndexOf('?') - 1);

        if(string.match(/\//)){
          var str_replace = string.replace(/\//, '');
          collectionUrl = collectionUrl.replace(string, '');
          collectionUrl = collectionUrl+str_replace;
          AT_Main.filterCatalogReplace(collectionUrl, filter_id);
        }
        else{
          AT_Main.filterCatalogReplace(collectionUrl, filter_id);
        }
      }
      else{
        var value = collectionUrl.substring(collectionUrl.lastIndexOf('/') + 1);

        collectionUrl = collectionUrl.replace(value, '');

        value = value.replace('#', '');

        var value_arr = value.split('+');

        var current_arr = [];
        jQuery('#'+filter_id+' li.active-filter').each( function() {
          current_arr.push(jQuery(this).attr('data-handle'));
        });

        jQuery('#'+filter_id+' li.active-filter').find('a').attr('title', '');
        jQuery('#'+filter_id+' li').removeClass('active-filter');

        for(jQueryi = 0; jQueryi<current_arr.length; jQueryi++) {
          value_arr = jQuery.grep(value_arr, function( n, i ) { return ( n !== current_arr[jQueryi]  ); });
        }

        var new_data = value_arr.join('+')

        var new_url = collectionUrl+new_data;

        if( typeof AT_Filter != 'undefined' && AT_Filter ){
          AT_Filter.updateURL = true;
          AT_Filter.requestPage(new_url);
        }else{
          window.location = new_url;
        }
      }

    });
  }
  ,recov_handleClick : function(){
    // Handle menu sidebar
    $(document).on('click','.categories-menu .dropdown, .sidebar-column .sb-filter',function(event){
      event.preventDefault();
      if ($(this).hasClass('active') && !$(this).hasClass('del-before')){
        $(this).removeClass('active');
      }else{
        $(this).parent().children().each(function(){
          if (!$(this).hasClass('del-before')) {
            $(this).removeClass('active');
          }
        })
        $(this).addClass('active');
      }
    })
  }
  ,swatch : function(){
    jQuery('.swatch :radio').change(function() {
      var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
      var optionValue = jQuery(this).val();
      jQuery(this)
      .closest('form')
      .find('.single-option-selector')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');

    });
  }

  ,switchImgProduct: function() {
    $('.product-wrapper .swatch-element > input').on('change', function(e){
      e.stopPropagation();
      var imgUrl = $(this).data("swatch-image"),
      parent = $(this).parents('.product-wrapper'),
      imgElem = parent.find('.product-image img');
      imgElem.parents('.product-image').addClass('img-loading');
      imgElem.attr('src', imgUrl)
      var fakeImg = new Image();
      fakeImg.src = imgUrl;
      fakeImg.onload = function(event){
        imgElem.parents('.product-image').removeClass('img-loading');
      };
      fakeImg.onerror = function() {
                //Code for error loading
              };
            });
  }

  ,slickProductPage: function(){

    jQuery('.slider-for-03').length && jQuery('.slider-for-03').slick({
      slidesToShow: 1
      ,slidesToScroll: 1
      ,arrows: true
      ,fade: true
      ,asNavFor: '.slider-thumbs-03'
      ,nextArrow: $('.slick-btn-03 .btn-next')
      ,prevArrow: $('.slick-btn-03 .btn-prev')
    });

    jQuery('.slider-thumbs-03').length && jQuery('.slider-thumbs-03').slick({
      infinite: false
      ,slidesToShow: 6
      ,slidesToScroll: 1
      ,asNavFor: '.slider-for-03'
      ,dots: false
      ,arrows: false
      ,focusOnSelect: true
    });

    jQuery('.slider-for-06').length && jQuery('.slider-for-06').slick({
      slidesToShow: 1
      ,slidesToScroll: 1
      ,infinite: false
      ,vertical: true
      ,verticalSwiping: true 
      ,arrows: true
      ,asNavFor: '.slider-thumbs-06'
      ,nextArrow: $('.slick-btn-06 .btn-next')
      ,prevArrow: $('.slick-btn-06 .btn-prev')

    });

    jQuery('.slider-thumbs-06').length && jQuery('.slider-thumbs-06').slick({
      infinite: false
      ,slidesToShow: 6
      ,slidesToScroll: 1
      ,vertical: true
      ,verticalSwiping: true
      ,asNavFor: '.slider-for-06'
      ,dots: false
      ,arrows: false
      ,focusOnSelect: true
    });
  }


  ,scareWidth : function(){
    var _name_width = 110;
    jQuery('.variants-wrapper .selector-wrapper').find('label').each(function( index,value ){
      _name_width = jQuery(value).width() > _name_width ? jQuery(value).outerWidth() : _name_width;
    });
    jQuery('.product-code span:first-child').css('width',_name_width);
    jQuery('.product-qty, .quantity').find('label').css('width',_name_width);

    jQuery('.variants-wrapper .selector-wrapper').find('label').css('width','70px');
    jQuery('.swatch.size').find('.header').css('width','70px');
    jQuery('.swatch.color, .swatch.colour').find('.header').css('width','70px');

  }

  ,scareName : function(){
    var _name_height = 0;
    jQuery('.cata-product .product-wrapper, .product-slider-section .row .product-wrapper').find('h5.product-name').each(function( index,value ){
      _name_height = jQuery(value).height() > _name_height ? jQuery(value).height() : _name_height;
    });
    jQuery('.cata-product .product-wrapper, .product-slider-section .row .product-wrapper').find('h5.product-name').css('height',_name_height);
  }
  ,scareScreen : function(){
    if( typeof _bc_config == "undefined" ){
      return;
    }
    var _current = this;

    if( _bc_config.enable_title_blance == "true" ){
      this.scareName();
    }

    jQuery( document ).ajaxComplete(function( event,request, settings ) {
      if( _bc_config.enable_title_blance == "true" ){
        _current.scareName();
      }
    });
  }


  ,parallaxScroll : function(e,p){
    if (typeof e != 'undefined' || typeof p != 'undefined') {
      jQuery(window).on('scroll.parallax', function(){
        var pos = jQuery(window).scrollTop();
        var elem = e;//jQuery('.slideshow-catalog-wrapper');
        var top = elem.offset().top;
        var elemH = elem.height();
        var windowHeight = jQuery(window).height();
        var param =  p;//jQuery('.swiper-slide');

        if (pos>top + elemH||pos<top||top > pos + windowHeight) {
          param.each(function(){
            param.css('transform', 'translateY(0px)');

          })
          return;
        }

        param.each(function(){
          param.css('transform', 'translateY(' + Math.round((pos-top) * 0.35) + 'px)');

        })
      });
    }
  }
  ,toggleFalling : function(check){
    jQuery(document).octoberLeaves({
      leafStyles: 3,      // Number of leaf styles in the sprite (leaves.png)
      speedC: 2,          // Speed of leaves
      rotation: 2,        // Define rotation of leaves
      rotationTrue: 1,    // Whether leaves rotate (1) or not (0)
      numberOfLeaves: 13, // Number of leaves
      size: 35,
      cycleSpeed: 35      // General size of leaves, final size is calculated randomly (with this number as general parameter)
    })

    
        $('.october-leaf').addClass('winter');
    

    if (check) {
      jQuery(document).octoberLeaves('start');
      $.cookie('check-falling','yes', {expires: 1, path: '/'});
    }
    else{
      jQuery(document).octoberLeaves('stop');
      $.cookie('check-falling','no', {expires: 1, path: '/'});
    }
  }
  ,effectFalling_handle : function(){
    if (AT_Main.getWidthBrowser() >= 992 && $('body').data('effect-falling')){
      $('#effect-falling').addClass('d-lg-block');
        if ($.cookie('check-falling') == "no") {
          $('#check-falling').prop('checked', false);
          AT_Main.toggleFalling(false);
        }else{
          $('#check-falling').prop('checked', true);
          AT_Main.toggleFalling(true);
        }

        jQuery('#check-falling').on('click',function(){
          AT_Main.toggleFalling($('#check-falling').is(':checked'));
        })

    }else{
      $('#effect-falling').removeClass('d-lg-block');
      AT_Main.toggleFalling(false);
    }
  }
  ,blogTags : function(){
   let activeTag = false;
   jQuery('.menu-list-tag').each(function(index){
    if (jQuery(this).hasClass('active')){
      activeTag = true;
    }
   })

     if(!activeTag)
      jQuery('.menu-list-tag').first().addClass('active');
  }

  ,onePage_config : function(){
    if ($('body').hasClass('templateIndex') && $('body').hasClass('theme-one-page')) {
      $(".main-content").onepage_scroll({
       sectionContainer: ".main-content .shopify-section"
       ,easing: "ease",
       animationTime: 1000,
       pagination: true,
       updateURL: false,
       beforeMove: function(index) {
         if(index == 1){
          $('.header-content').css('display','block');
        }else{
          $('.header-content').css('display','none');
        }
      },
      afterMove: function(index) {

      },
      loop: true,
      keyboard: true,
      responsiveFallback: false,
      direction: "vertical"
    });
    }
  }
  ,scrollMouse: function(){
    $('.scroll-mouse').on('click',function(e){
      e.preventDefault();
      let x = $('.main-content .shopify-section').first().next().offset().top;
      jQuery('body,html').animate({scrollTop:x},800,'swing');
    })
  }
  ,fixedHeader : function(){
    $('.topbar-close').click(()=>{
      $('#topbar-main').removeClass('d-lg-block');
    })
    if($('#header-style').hasClass('style-left-menu')){
      $('body').addClass('theme-left-menu');
      $('#footer-content').remove();
    }
    if ($('.mobile-version').data('show-translate')) {
      setTimeout(function(){
        if($('#header-style').data('style') == '4' || $('#header-style').data('style') == '5'){
          $(".header-container-top .list-inline.translate--move").prepend($('#translate-mobile'));
        }
        $('.style-left-menu').length && $(".header-container .list-inline.translate--move").prepend($('#translate-mobile'));

      },1000);
    }
  }

  ,menuOnMobile_handle : function(){

    if($('.mobile-version .mega-menu .position-left').length > 0 || $('.mobile-version .mega-menu .position-center').length > 0 || $('.mobile-version .mega-menu .position-right').length > 0){
      $('.mobile-version .mega-menu .position-left,.mobile-version .mega-menu .position-center,.mobile-version .mega-menu .position-right').attr('style','');
      $('.mobile-version .mega-menu .mega-col').each(function(){
        $(this).parents('.row').first().before($(this).children());
      })
      $('.mobile-version .mega-menu .row').remove();
    }

    if($('.mobile-version .mega-menu .menu-proudct-carousel').length > 0){
      setTimeout(function(){
        $('.mobile-version .mega-menu .menu-proudct-carousel').prepend('<div class="back-prev-menu"><span class="expand"></span></div>');
      },500);
    }
    jQuery(document).on('click','.mobile-version .menu-mobile .main-nav .expand',function(event){
      let title = $(this).parent().find('a').first().text().trim().split('\n')[0];
      let e = $(this).parents('.dropdown').first();

      if(e.parent().hasClass('col-item')){
        e.parent().addClass('active');
        e.parents('.dropdown-menu').first().addClass('sub-open');
      }
      else{
        e.addClass('active');
        e.parent().addClass('sub-open');
      }
      if (e.hasClass('dropdown') ) {
        let child = e.children('.dropdown-menu');
        if(child.length > 0){
          if (child.hasClass('menu-mobile-open') == false) {
            if(child.find('.banners').length > 0){
              child.find('.banners').each(function(){
                let el = $(this);
                if (el.hasClass('no-title-2')) {
                  let img = el.children('.dropdown-menu').find('img');

                  let temp = el.children('.dropdown-menu').find('img').parents('li').first().html();
                  el.append(el.html(temp).removeClass('dropdown'));

                  if (img.length > 0 && !img.hasClass('lazyloaded')) {
                    el.addClass('hide')
                  }else{
                    el.removeClass('hide')
                  }

                }
              })
            }
            child.addClass('menu-mobile-open');
            if (title.length > 0) {
              child.children('.back-prev-menu').find('.expand').html(title);
            }
            return false;
          }
        }
      }

      if ($(this).parent().hasClass('back-prev-menu')) {
        let e = $(this).parent();
        e.parents('.dropdown-menu').first().removeClass('menu-mobile-open');

        if(e.parents('.dropdown').first().parent().hasClass('col-item')){
          e.parents('.dropdown').first().parent().removeClass('active');
          e.parents('.sub-open').first().removeClass('sub-open');
        }
        else{
          e.parents('.dropdown').first().removeClass('active');
          e.parents('.dropdown').first().parent().removeClass('sub-open');
        }
      }

    });
  }
  ,megamenuWithTabs : function(){
    jQuery(".tab-title .title-item").hover(function(e){
      $('.title-item').removeClass('active');
      $('.tab-content-inner').removeClass('active');

        var _class = $(this).attr('data-id');
        var idclass = "." + _class;
        var e = jQuery(this);

        e.addClass('active');
        $(idclass).addClass('active');
    });

    jQuery(".mega-menu").mouseleave(function(){
      $('.title-item').removeClass('active');$('.title-item-1').addClass('active');
      $('.tab-content-inner').removeClass('active');$('.mm-tabs-1').addClass('active')
    });
  }
  ,productDescription : function(){
    $('.nav-ver-2 li a').on('click',function(e){
      e.preventDefault();

      if ($(this).parent().hasClass('active')) {
        $(this).parent().removeClass('active').find('.tab-pane').removeClass('show active');
      }else{
        $('.nav-ver-2 li').removeClass('active').find('.tab-pane').removeClass('show active');
        $(this).parent().addClass('active').find('.tab-pane').addClass('show active');
      }
    })
  }
  ,deadLine_time : function(){
    var _deadline_time = parseInt($('.shipping-time').attr('data-deadline'));
    var _currentDate = new Date();

    var _dueDate = new Date( _currentDate.getFullYear(), _currentDate.getMonth(), _currentDate.getDate());
    _dueDate.setHours(_deadline_time);

    switch(_currentDate.getDay()) {
      case 0: // Sunday
      _dueDate.setDate(_dueDate.getDate() + 1);
      break;

      case 5: // Friday
      if(_currentDate >= _dueDate){
        _dueDate.setDate(_dueDate.getDate() + 3);
      }
      break;

      case 6: // Saturday
      _dueDate.setDate(_dueDate.getDate() + 2);
      break;

      default:
      if(_currentDate >= _dueDate){
        _dueDate.setDate(_dueDate.getDate() + 1);
      }
    }

    $('.countdown_deadline').countdown({until: _dueDate, format: 'HMS', padZeroes: true});
  }

  ,delivery_time : function(){
      var today = new Date();
      var business_days = parseInt($('.shipping-time').attr('data-deliverytime'));
        var deliveryDate = today; //will be incremented by the for loop
        var total_days = business_days; //will be used by the for loop

        for(var days=1; days <= total_days; days++) {
          deliveryDate = new Date(today.getTime() + (days *24*60*60*1000));
          if(deliveryDate.getDay() == 0 || deliveryDate.getDay() == 6) {
            //it's a weekend day so we increase the total_days of 1
            total_days++
          }
        }

        var weekday = new Array(7);
        weekday[0] =  "Sunday";
        weekday[1] = "Monday";
        weekday[2] = "Tuesday";
        weekday[3] = "Wednesday";
        weekday[4] = "Thurday";
        weekday[5] = "Friday";
        weekday[6] = "Saturday";
        var _day = weekday[deliveryDate.getDay()];

        var month = new Array();
        month[0] = "January";
        month[1] = "February";
        month[2] = "March ";
        month[3] = "April";
        month[4] = "May";
        month[5] = "June";
        month[6] = "July";
        month[7] = "August";
        month[8] = "September";
        month[9] = "October";
        month[10] = "November";
        month[11] = "December";
        var _month = month[deliveryDate.getMonth()];

        $('.delivery-time').html('Want it delivered by' + '&nbsp;' + '<strong>' + _day + ',' + '&nbsp;' + deliveryDate.getDate() + '&nbsp;' + _month + '?' + '</strong>');
      }

  ,initParallax : function(){
    if ($('.large-img .img').length > 0) {
      AT_Main.parallaxScroll($('.large-img'),$('.large-img .img'));
    }
  }
  ,initIsotope : function(){
    if( jQuery('.home-banner-masonry').length > 0 ){
      if( 'undefined' === typeof Isotope ){
        console.log(" Isotope has not defined yet! ");
        return;
      }
      $('.home-banner-masonry').each(function(){
        var $isotope = $('.bc-masonry', this);
        $isotope.isotope({
          itemSelector: '.banner-item',
          layoutMode: 'packery'
        });

        $isotope[0].addEventListener('load', (function(){
          var runs;
          var update = function(){
            $isotope.isotope('layout');
            runs = false;
          };
          return function(){
            if(!runs){
              runs = true;
              setTimeout(update, 33);
            }
          };
        }()), true);

      });
    }

     if( jQuery('.blog-masonry').length > 0 ){

      if( 'undefined' === typeof Isotope ){
        console.log(" Isotope has not defined yet! ");
        return;
      }
      $('.page-blog').each(function(){
        var $isotope = $('.page-blog-content', this);
        $isotope.isotope({
          itemSelector: '.post-item',
          layoutMode: 'packery'
        });

        $isotope[0].addEventListener('load', (function(){
          var runs;
          var update = function(){
            $isotope.isotope('layout');
            runs = false;
          };
          return function(){
            if(!runs){
              runs = true;
              setTimeout(update, 33);
            }
          };
        }()), true);

      });
    }
  }

  ,resizeCollection : function(){
    let sb = $('.sidebar-column');
    if (sb.length > 0 ) {
      let filter = $('.page-cata').find('.filter-component');
      if (AT_Main.getWidthBrowser() < 992 ){
        filter.removeClass('accordion full toggle').attr('style', '').addClass('drawer');

      }else{
        filter.removeClass('drawer').addClass(filter.data('filter'));
        jQuery("#page-body").trigger('click');
      }
    }
  }
  ,quickShop_drawerHandle : function(){
    $('#page-body').on('click',function(){
      AT_Main.fixReturnScroll();
      if ($('body').hasClass('qs-opened')) {
        $('body').removeClass('qs-opened');
        $('.qs-drawer').removeClass('show');

      }
    })
  }
  ,zoom_img_init : function(){
    $('.image-zoom').trigger('zoom.destroy');
    if (AT_Main.getWidthBrowser() > 991 ) {

      $('.image-zoom').parent().zoom({
        url: $(this).find('img').attr('data-zoom'),
        on:'mouseover',
        touch:true
      });
     }
  }
  ,updateLayerCart : function(name,image){
    let img = `<img src="${image}" alt="${name}">`;
    let prod_name = `"${name}"`;

    if (image == null){$('.cart-img').css('display', 'none');}
    else{$('.cart-img').empty().html(img);}

    $('.cart-prod').empty().html(prod_name);

    setTimeout(function(){
      $('.new-loading.loading').length&&$('.new-loading').removeClass('loading');
      $('.layer-addcart-modal').addClass('show');
    },500)
  }
  ,init_CountDown : function(){

    if ($('.detail-deal').length) {
      let currentDate = new Date();
      $('.detail-deal').each(function(){
        let $this = $(this), child = $this.children();
        let prod_id = child.data('id');
        let prod_dueDate = child.data('date');
        let dueDate = prod_dueDate.split('/');
        var newdueDate = new Date( Number(dueDate[2]) , Number(dueDate[0]) - 1, Number(dueDate[1]));

        if(currentDate < newdueDate){
          $('.countdown_'+prod_id).countdown({until: newdueDate,format: 'DHMS'});
          $this.removeClass('hide');
        }
      });
    }
  }
  ,fixProductPage : function(){
    if ($('.page-product').length) {
      AT_Main.zoom_img_init();
      if (AT_Main.getWidthBrowser() > 991 && $('.slider-for-06').length) {
        setTimeout(function(){
          let imageH = 0;
          $('#product-image .slider-for-06 .slick-slide').each(function(){
            imageH = $(this).outerHeight() > imageH ? $(this).outerHeight() : imageH;
          })
          $('#product-image .slider-thumbs-06 .slick-list.draggable, #product-image .slider-for-06 .slick-list.draggable').css('height', imageH);
        },500)
      }
    }
  }
  ,initOnLoad : function(){
    $('#page-body').removeClass('opacity-0');
    $('body').removeClass('f-load');
    $('.new-loading').removeClass('loading');    
    $('html').easeScroll();
  }
  ,init : function(){

    if( typeof _bc_config == 'undefined' ){
     console.log( " _bc_config is undefined " );
     return ;
   }

   this.stickMenu();
   this.toTopButton();
   this.mailchipPopup();
   this.toggleVerticalMenu();
   this.toggleCartSidebar();
   this.toggleFilterSidebar();
   this.handleGridList();
   this.effectNavigation();
   this.fixButton();
   this.menuOnMobile();
   this.handleMenuMultiLine();
   this.fixTitle();
   this.filterCatalog();
   this.swatch();
   this.switchImgProduct();
   this.slickProductPage();
   this.init_handle();
   this.blogTags();
   this.onePage_config();
   this.effectFalling_handle();
   this.scrollMouse();
   this.fixedHeader();
   this.menuOnMobile_handle();
   this.megamenuWithTabs();
   this.productDescription();
   this.initParallax();
   this.initIsotope();
   this.init_CountDown();
   this.resizeCollection();
   this.quickShop_drawerHandle();
   this.recov_handleClick();
  }
  ,init_handle : function(){

    $('.new-loading').after($('.mobile-version'))

    $('.rating-links a').click(function() {
      $('.product-simple-tab ul li a').removeClass('active');
      $('#tab_review_tabbed a').addClass('active');
      $('.product-simple-tab .tab-content .tab-pane').removeClass('show active');
      $('#tab-review').addClass('show active');
      $('#tab_review_tabbed').scrollToMe();
      return false;
    });

    if ($('.shipping-time').length > 0) {
      AT_Main.deadLine_time();
      AT_Main.delivery_time();
    };
    AOS.init({delay:500,once:true});
    setTimeout(function(){
      if($('#translate-mobile').find('.icon-angle-down').length == 0 )
        $('.goog-te-combo, .prod-bundle-select').after('<i class="icon-angle-down"></i>');
    },3000)

    if (jQuery("#vidPlayer").length > 0) {
      jQuery("#vidPlayer").YTPlayer();
    };
    if (jQuery("#vidPlayer-mobile").length > 0) {
      jQuery("#vidPlayer-mobile").YTPlayer();
    };


  }
}
/* Handle when window resize */
jQuery(window).resize(function() {

    AT_Main.fixReturnScroll();/*Reset Page when fixNoScroll had called before*/
    AT_Main.resizeCollection();
    AT_Main.effectFalling_handle();
    AT_Main.fixProductPage();    
    if(AT_Main.checkLayout() != 1 && jQuery('.menu-mobile').hasClass('opened')){
      jQuery("#page-body").trigger('click');
    }
});

jQuery(window).on('load', AT_Main.initOnLoad)

jQuery(document).ready(function($) {
 AT_Main.init();
});

document.addEventListener('shopify:section:load', event => {// Handle on shopify customize
  AT_Main.init();
  AT_Slider.init();
})